
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/56a93c57fa1a2b98007b712d4cf9f1b7.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-left max-w-3xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 font-['Playfair_Display'] leading-tight">
            Crafting Luxury
            <span className="block text-[#D4AF37]">Outdoor Living</span>
            <span className="block">Spaces</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 font-light leading-relaxed">
            Transform your outdoor space with our premium landscape construction and innovative 3D design renderings. 
            Experience the perfect blend of luxury, functionality, and natural beauty.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg"
              onClick={() => scrollToSection('contact')}
              className="transform hover:scale-105"
            >
              <i className="ri-phone-line mr-2"></i>
              Get a Quote
            </Button>
            <Button 
              variant="outline"
              size="lg"
              onClick={() => scrollToSection('portfolio')}
              className="bg-white/10 backdrop-blur-sm border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transform hover:scale-105"
            >
              <i className="ri-image-line mr-2"></i>
              View Our Designs
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('about')}
          className="text-white/70 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
